import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import RequestDemoModal from './RequestDemoModal';

// v3_fix_issues #11 - every vertical UI has a footer with Terms & Conditions and a working
// "Request a Demo". Kept deliberately low-key (small, muted).
export default function Footer() {
  const [showDemo, setShowDemo] = useState(false);
  return (
    <footer className="border-top mt-5 py-4 text-muted small">
      <div className="container d-flex flex-column flex-md-row justify-content-between align-items-center gap-2">
        <div>© {new Date().getFullYear()} RentalVerse. All rights reserved.</div>
        <div className="d-flex align-items-center gap-3">
          <Link to="/terms" className="text-muted">Terms &amp; Conditions</Link>
          <Button variant="link" size="sm" className="p-0 text-muted align-baseline" onClick={() => setShowDemo(true)}>
            Request a Demo
          </Button>
        </div>
      </div>
      <RequestDemoModal show={showDemo} onHide={() => setShowDemo(false)} />
    </footer>
  );
}
